import { render, staticRenderFns } from "./StoreList.vue?vue&type=template&id=70cf4866&scoped=true"
import script from "./StoreList.vue?vue&type=script&lang=js"
export * from "./StoreList.vue?vue&type=script&lang=js"
import style0 from "./StoreList.vue?vue&type=style&index=0&id=70cf4866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cf4866",
  null
  
)

export default component.exports